"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcuantDocumentClassEnumToJSON = exports.AcuantDocumentClassEnumFromJSONTyped = exports.AcuantDocumentClassEnumFromJSON = exports.AcuantDocumentClassEnum = void 0;
/**
 * Document types recognized by Acuant
 * @export
 * @enum {string}
 */
var AcuantDocumentClassEnum;
(function (AcuantDocumentClassEnum) {
    AcuantDocumentClassEnum["Unknown"] = "Unknown";
    AcuantDocumentClassEnum["Passport"] = "Passport";
    AcuantDocumentClassEnum["Visa"] = "Visa";
    AcuantDocumentClassEnum["DriversLicense"] = "Drivers License";
    AcuantDocumentClassEnum["IdentificationCard"] = "Identification Card";
    AcuantDocumentClassEnum["Permit"] = "Permit";
    AcuantDocumentClassEnum["Currency"] = "Currency";
    AcuantDocumentClassEnum["ResidenceDocument"] = "Residence Document";
    AcuantDocumentClassEnum["TravelDocument"] = "Travel Document";
    AcuantDocumentClassEnum["BirthCertificate"] = "Birth Certificate";
    AcuantDocumentClassEnum["VehicleRegistration"] = "Vehicle Registration";
    AcuantDocumentClassEnum["Other"] = "Other";
    AcuantDocumentClassEnum["WeaponLicense"] = "Weapon License";
    AcuantDocumentClassEnum["TribalIdentification"] = "Tribal Identification";
    AcuantDocumentClassEnum["VoterIdentification"] = "Voter Identification";
    AcuantDocumentClassEnum["Military"] = "Military";
    AcuantDocumentClassEnum["INVALIDVALUE"] = "_INVALID_VALUE";
})(AcuantDocumentClassEnum = exports.AcuantDocumentClassEnum || (exports.AcuantDocumentClassEnum = {}));
function AcuantDocumentClassEnumFromJSON(json) {
    return AcuantDocumentClassEnumFromJSONTyped(json, false);
}
exports.AcuantDocumentClassEnumFromJSON = AcuantDocumentClassEnumFromJSON;
function AcuantDocumentClassEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AcuantDocumentClassEnumFromJSONTyped = AcuantDocumentClassEnumFromJSONTyped;
function AcuantDocumentClassEnumToJSON(value) {
    return value;
}
exports.AcuantDocumentClassEnumToJSON = AcuantDocumentClassEnumToJSON;
//# sourceMappingURL=AcuantDocumentClassEnum.js.map